import React, {
  ComponentType,
  useState
} from 'react'
import {
  Dropdown,
  Responsive
} from 'semantic-ui-react'
// Local
import {
  expandSpecialtyFilter,
  specialtyFilterKeys
} from './ruleFilterUtils'

const SafeResponsive = Responsive as unknown as ComponentType<any>
const SafeDropdown = Dropdown as unknown as ComponentType<any>

type DropdownOption = {
  key: string
  value: string
  text: string
  id: string
}

type SpecialtySelectProps = {
  onChange?: (
    event: React.SyntheticEvent,
    data: {
      name: string
      value: string | string[]
    }
  ) => void
  name?: string
  value?: string | string[]
  placeholder?: string
  multiple?: boolean
}

/**
 * Provides a stand-alone select widget that allows you to select the specialty
 * Thus the CDI role can focus on Cardiology encounters, Nephrology encounters, etc.
 *
 * @param onChange Callback function on potential count select
 *   Arguments: (e, {name, value}) where value is the specialty
 *    or "" if the ALL option is selected
 * @param name Name of the select widget in a form context. Default:
 *   specialty
 * @param value Initial selected specialties
 * @param placeholder Placeholder text. Default: Specialty
 * @param multiple Allow multiple selections. Default: true
 */
function SpecialtySelect(props: SpecialtySelectProps): JSX.Element {
  const {
    onChange: onChangeProp,
    name: nameProp,
    value: valueProp,
    placeholder: placeholderProp,
    multiple: hasMultipleProp
  } = props

  const [ specialty ] = useState<string[]>(specialtyFilterKeys())
  const isMultiple = hasMultipleProp !== false

  const handleChange = (
    event: React.SyntheticEvent,
    data: {
      value: string | string[]
    }
  ) => {
    if (onChangeProp) {
      const name = nameProp || 'specialty'
      onChangeProp(
        event,
        {
          name,
          value: data.value
        }
      )
    }
  }

  const options: DropdownOption[] = specialty.map(element => ({
    key: element,
    value: element,
    text: expandSpecialtyFilter(element),
    id: `specialty-${element.toLowerCase()}`
  }))

  const placeholder = placeholderProp || 'Specialty'
  const id = 'specialty-select'

  if (isMultiple === true) {
    const value = valueProp || []
    return (
      <SafeResponsive
        as={ SafeDropdown }
        id={ id }
        fluid
        multiple
        selection
        placeholder={ placeholder }
        onChange={ handleChange }
        options={ options }
        value={ value }
      />
    )
  }

  const value = valueProp || undefined
  return (
    <SafeResponsive
      as={ SafeDropdown }
      id={ id }
      fluid
      selection
      placeholder={ placeholder }
      onChange={ handleChange }
      options={ options }
      value={ value }
    />
  )
}

export default SpecialtySelect
